import React from 'react';
import { SectionWrapper } from './style';
export const PrivaceNotive = () => {
  return (
    <SectionWrapper>
      <h1 className="title">AVISO DE PRIVACIDADE DPO HUB</h1>
      <p>Bem-vindos ao DPOHub!</p>
      <p>
        Na Daniel Advogados temos inovação e tecnologia em nosso DNA. Nós impulsionamos inovação e
        tecnologia nos nossos serviços jurídicos, garantindo maior segurança jurídica aos nossos
        clientes e fazemos isso de um jeito diferente. O DPOHub foi desenvolvido pela Daniel
        Advogados para oferecer aos clientes serviços jurídicos de forma mais ágil e interativa. Ao
        acessá-lo, você poderá controlar seu orçamento, visualizar suas demandas em tempo real,
        fazer autoavaliações (self-assessments) e solicitar novas consultas a qualquer tempo.
      </p>
      <p>
        Como essas atividades implicam, necessariamente, tratamento de alguns de seus dados
        pessoais, apresentamos este Aviso de Privacidade, para que você tenha maior transparência e
        segurança ao utilizá-lo.
      </p>
      <h2 className="subTitle">
        <span>1.</span> PRINCIPAIS CONCEITOS
      </h2>
      <p>
        Antes de adentrarmos ao tema principal deste Aviso, gostaríamos de esclarecer a você alguns
        conceitos importantes para a boa leitura deste material.
      </p>
      <p>
        Para fins de entendimento, quando falarmos neste Aviso “Nós”, “nós”, “Daniel Advogados” ou
        “Daniel”, estamos nos referindo à <strong>Daniel Advogados</strong> (CNPJ
        33.073.800/0001-91, Endereços: São Paulo - Rua Leopoldo Couto Magalhães Junior, 758, cj 52,
        5º andar, Condomínio New Century – Itaim Bibi - CEP: 04542-000, Tel.: (55 11) 2103.9107,
        Fax: (55 11) 2103.9124 e Rio de Janeiro - Avenida República do Chile, 330/ 21º andar - Torre
        Oeste – Centro - CEP: 20.031-170 Tel.: (55 21) 2102.4212, Fax: (55 21) 2524.3344)).
      </p>
      <p>
        Quando falamos em <strong>dados pessoais</strong>, nos referimos a todas as informações que
        de alguma forma identifique ou torne identificável um usuário, ou seja, seu nome, RG, CPF,
        entre outras informações.
      </p>
      <p>
        Já o <strong>tratamento de dados pessoais</strong>, nada mais é que qualquer operação que de
        alguma maneira a Daniel Advogados venha fazer com seus dados pessoais, ou seja, atividades
        relacionadas a coleta, produção, recepção, classificação, utilização, acesso, reprodução,
        transmissão, distribuição, processamento, arquivamento, armazenamento, eliminação, avaliação
        ou controle da informação, modificação, comunicação, transferência.
      </p>
      <p>
        Quando mencionamos <strong> “Você” </strong> ou <strong>“você”</strong>, nós estamos nos
        referindo aos usuários que acessam e utilizam a plataforma DPO Hub.
      </p>
      <p>
        A seguir você encontrará informações precisas a respeito de como seus dados pessoais serão
        tratados.
      </p>
      <h2 className="subTitle">
        <span>2.</span> QUAIS DADOS SÃO COLETADOS E COMO?
      </h2>
      <p> Os seus dados pessoais podem ser coletados da seguinte forma: </p>
      <ul>
        <li>
          Dados fornecidos mediante interação do titular com a plataforma DPO Hub ou através do
          preenchimento de cadastro na plataforma DPO Hub;
        </li>
        <li>
          Dados coletados automaticamente quando o titular navegar pela plataforma DPO Hub, como,
          por exemplo o endereço IP, localização, data e hora de acesso, cookies, dados de acesso e
          atividades realizadas dentro da Plataforma.
        </li>
      </ul>
      <p>Os seguintes dados são coletados:</p>
      <table>
        <tbody>
          <tr>
            <td className="table-td-top-left">Dados cadastrais</td>
            <td className="table-td-center">
              <ul>
                <li> Nome completo</li>
                <li>Documento</li>
                <li>Data de nascimento</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className="table-td-top-left">Dados de contato</td>
            <td className="table-td-center">
              <ul>
                <li> Endereço de e-mail</li>
                <li>Endereço residencial</li>
                <li>Telefone</li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className="table-td-top-left">Dados profissionais</td>
            <td className="table-td-center">
              <ul>
                <li> Empresa </li>
                <li>DÁrea de Atuação</li>
                <li>Faturamento estimado </li>
                <li>Tributos </li>
                <li>Histórico de simulações </li>
              </ul>
            </td>
          </tr>
          <tr>
            <td className="table-td-top-left">Dados de atividade</td>
            <td className="table-td-center">
              <ul>
                <li> Endereço IP </li>
                <li>Localização </li>
                <li>Data e hora de acesso </li>
                <li>Cookies </li>
              </ul>
            </td>
          </tr>
        </tbody>
      </table>
      <p>
        Embora você possa optar por não divulgar certas informações, esta decisão pode privá-lo de
        alguns dos serviços e recursos que oferecemos. As informações essenciais para a prestação de
        nossos serviços e recursos são identificadas.
      </p>
      <h2 className="subTitle">
        <span>3.</span> COMO UTILIZAMOS SEUS DADOS PESSOAIS?
      </h2>
      <p>
        O tratamento dos dados pessoais indicados acima ocorrerá para cumprir o contrato de
        prestação de serviço estabelecido entre você e a Daniel Advogados, ou para cumprimento de
        obrigações legais a que estejamos sujeitos. No entanto, existem outras finalidades para as
        quais realizamos o tratamento dos seus dados, como a realização de monitoramento contínuo e
        regular de nossa infraestrutura de tecnologia da informação para aperfeiçoamento e promoção
        de serviços, bem como para garantia de segurança e prevenção de fraudes.
      </p>
      <h2 className="subTitle">
        <span>4.</span> COM QUEM COMPARTILHAMOS OS SEUS DADOS PESSOAIS?
      </h2>
      <p>
        Seus dados pessoais somente são compartilhados apenas quando necessário para manutenção dos
        serviços e nós o fazemos apenas com fornecedores que participam, direta ou indiretamente, do
        desenvolvimento das atividades da Daniel, como serviços de hospedagem ou armazenamento de
        dados.
      </p>
      <h2 className="subTitle">
        <span>5.</span> MEDIDAS DE SEGURANÇA
      </h2>
      <p>
        Em todas as suas atividades, a Daniel toma as medidas de segurança técnica, jurídica e
        administrativa para melhor proteção dos seus dados pessoais.
      </p>
      <p>
        Em algumas atividades, seus dados poderão ser transferidos para outros países, como os
        Estados Unidos (por exemplo, para hospedagem) ou Estados-membros da União Europeia (por
        exemplo, para nossos serviços no exterior). A Daniel sempre toma as medidas cabíveis para
        garantir o nível adequado de segurança e proteção de dados pessoais nesses casos.
      </p>
      <h2 className="subTitle">
        <span>6.</span> POLÍTICA DE COOKIES
      </h2>
      <ul>
        <li className="styleAlphabetic">O que é um cookie?</li>
        <p>
          Quando você usa o DPO Hub, a Daniel pode armazenar um arquivo chamado “cookie” em seu
          dispositivo (computador, tablet, etc.) através de seu navegador.
        </p>
        <p>
          Cookies são arquivos ou informações que podem ser armazenadas em seus dispositivos, quando
          você visita à Plataforma. Geralmente, um cookie contém o nome do site que o originou, seu
          tempo de validade e um valor, que é gerado aleatoriamente.
        </p>
        <p>
          Os cookies permitem, durante seu período de registro, identificar seu computador em suas
          próximas visitas. Desta forma, cada vez que você visitar a plataforma, os dados de sua
          visita anterior poderão ser retidos.
        </p>
        <p>
          Nós utilizamos cookies para facilitar o uso e melhor adaptar a plataforma aos seus
          interesses e necessidades, bem como para compilarmos informações sobre a utilização de
          nossos sites e serviços, auxiliando a melhorar suas estruturas e seus conteúdos. Os
          cookies também podem ser utilizados para acelerar suas atividades e experiências futuras.
        </p>
        <li className="styleAlphabetic"> Quais dados o DPO Hub utiliza? </li>
        <p>A Plataforma utiliza os seguintes cookies:</p>
      </ul>
      <ul>
        <li className="indent">
          <strong>Cookies Necessários:</strong> para que os serviços do DPOHub carreguem
          corretamente e permita que você navegue e faça uso de todas as funcionalidades
          disponíveis, normalmente;
        </li>
        <li>
          <strong> Cookies Funcionais:</strong> que permitem que o DPOHub se lembre das escolhas dos
          Usuários, para proporcionar uma experiência mais personalizada.
        </li>
      </ul>
      <h2 className="subTitle">
        <span>7.</span> PERÍODO DE RETENÇÃO DE DADOS
      </h2>
      <p>
        Os dados coletados por meio do DPOHub serão retidos apenas pelo período estritamente
        necessário para o cumprimento das finalidades apontadas acima.
      </p>
      <p>
        Os dados referentes aos registros de acesso (data, hora e IP) serão armazenados, em regra,
        pelo período de 6 meses, para cumprimento do Marco Civil da Internet. Os dados coletados por
        meio de cookies serão armazenados pelo período máximo de 90 dias.
      </p>
      <h2 className="subTitle">
        <span>8.</span> QUAIS SÃO OS SEUS DIREITOS COMO TITULAR DE DADOS?
      </h2>
      <p>
        Fazer o melhor para garantir os seus direitos é nosso dia a dia. Na proteção dos seus dados
        pessoais não é diferente. A qualquer momento você tem a possibilidade de exercer seus
        direitos em relação aos dados pessoais que tratamos:
      </p>
      <ul>
        <li>
          <strong>Confirmação da existência de tratamento: </strong>
          obter a confirmação se há tratamento de seus dados;
        </li>
        <li>
          <strong> Acesso a dados: </strong>
          obter detalhes das informações pessoais utilizadas por nós;
        </li>
        <li>
          <strong> Correção de dados: </strong>
          corrigir, complementar ou atualizar seus dados;
        </li>
        <li>
          <strong> Anonimização ou bloqueio dos dados desnecessários: </strong>
          solicitar que seus dados sejam restringidos ou eliminados, nos casos em que esta
          solicitação não restrinja nossos direitos de manter os dados conforme a legislação assim o
          permita;
        </li>
        <li>
          <strong> Portabilidade dos dados a outro fornecedor:</strong> a portabilidade dos seus
          dados dependerá, necessariamente, das definições apresentadas pela autoridade nacional,
          resguardados os interesses e segredos comerciais da Daniel Advogados protegidos por lei;
        </li>
        <li>
          <strong> Informação de compartilhamento de dados: </strong>
          solicitar informações sobre as entidades com as quais nós compartilhamos os seus dados;
        </li>
        <li>
          <strong>Informação sobre não fornecer consentimento: </strong> a ausência do fornecimento
          do consentimento poderá inviabilizar a prestação de alguns de nossos serviços relacionados
          ao programa.
        </li>
        <li>
          <strong>Revogação do consentimento: </strong> a Daniel Advogados mantém opção facilitada
          de revogação do consentimento (opt-out) aplicável às situações em que este for solicitado;
        </li>
        <li>
          <strong>Oposição ao tratamento: </strong> caso compreenda que seus dados pessoais estejam
          sendo tratados em descumprimento à lei, você poderá se opor a esse tratamento;
        </li>
        <li>
          <strong> Exclusão: </strong>a qualquer momento, o usuário pode solicitar a exclusão de
          seus dados. A exclusão das informações essenciais para gestão de sua conta junto à Daniel
          poderá implicar no término de seu cadastro. Mesmo nesses casos, a Daniel poderá manter os
          dados pessoais armazenados, de modo a cumprir com suas obrigações legais de guarda de
          dados ou para defesa judicial de seus interesses. A Daniel Advogados empreenderá todos os
          esforços para atender tais pedidos no menor espaço de tempo possível. No entanto, mesmo em
          caso de requisição de exclusão, será respeitado o prazo de armazenamento mínimo de
          informações de usuários de aplicações de Internet, determinado pela legislação brasileira,
          sem prejuízo das demais obrigações legais existentes.
        </li>
      </ul>
      <p>
        Para exercer quaisquer dos direitos previstos neste Aviso de Privacidade, entre em contato
        pelo e-mail dpo@daniel-ip.com. Todas as solicitações serão atendidas de forma gratuita, e
        submetidas a uma prévia avaliação da sua identidade para garantir a segurança do seu
        atendimento.
      </p>
      <h2 className="subTitle">
        <span>9.</span> ENCARREGADO PELO TRATAMENTO DE DADOS PESSOAIS
      </h2>
      <p>
        A Daniel Advogados conta com um Encarregado pelo Tratamento de Dados Pessoais, ele é o canal
        de comunicação entre a Daniel e você sobre tudo o que diz respeito a proteção dos seus dados
        pessoais em nossas atividades. Em caso de dúvidas ou solicitações, entre em contato pelo
        e-mail <a href="mailto:dpo@daniel-ip.com">dpo@daniel-ip.com</a>.
      </p>
      <h2 className="subTitle">
        <span>10.</span> ATUALIZAÇÕES
      </h2>
      <p>
        A Daniel poderá modificar este Aviso de Privacidade a qualquer tempo e sempre o manterá
        atualizado no DPOHub.
      </p>
      <p className="right">Última atualização: maio/2023</p>
    </SectionWrapper>
  );
};
